<template>
  <div>
    <!-- Titlebar
        ================================================== -->
    <div
      class="bg_img_top static_page_bg"  v-if="!isAppView()"
      v-bind:style="{
        backgroundImage:
          terms_and_conditions_ptUser.image &&
          terms_and_conditions_ptUser.show_banner_image == 'yes'
            ? 'url(' + terms_and_conditions_ptUser.image + ')'
            : 'url(' + webUrl + 'assets/images/about-banner.webp)',
      }"
    >
      <!-- <div id="titlebar" class="gradient signup_mrgn faq_mrgn"> -->
      <div class="full_gragient">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <!--<h1 class="text-center faq_haed" v-html="terms_and_conditions_ptUser.title"></h1>-->
              <h1 class="text-center faq_haed">{{ terms_and_conditions_ptUser.title }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="isAppView() ? 'mt-0' : 'margin-top-50 mobile_tab_margin_top_35'"></div>
    <!-- Page Content
        ================================================== -->
    <div class="container">
      <div class="row">
        <div class="col-xl-12 common_block common_desc">
          <!-- <div class="selected_faq_radio">
            <input type="radio" v-model="x" value="terms_jobseeker" /><span class="first_span_radio"
              >Job Seekers</span
            >
            <input type="radio" v-model="x" value="terms_hirers" /><span>{{ $t('terms.tab_employers') }}</span>
          </div> --> 
          <!-- <h1 v-if="isAppView()">{{tab_type}}</h1> -->
           <div class="toggle_div_main_faq" :class="isAppView ? 'mobile_tg' : ''" v-if="!isAppView()">
              <div class="toggle_wrapper_faq taggle_wrapper_terms">
                  <div class="toggle_group_faq">
                      <label :class="['toggle_option_faq', { active: x === 'terms_jobseeker' }]">
                      <input type="radio" v-model="x" value="terms_jobseeker" @change="tab_type='Employee';getTermsConditions()"/>
                      {{ $t('terms.tab_jobseekers') }}
                      </label>

                      <label :class="['toggle_option_faq', { active: x === 'terms_hirers' }]">
                      <input type="radio" v-model="x" value="terms_hirers" @change="tab_type='Employer';getTermsConditions()"/>
                      {{ $t('terms.tab_employers') }}
                      </label>
                  </div>
              </div>
          </div>
          <div v-show="x === 'terms_jobseeker'" class="style_for_all_h3 style_for_all_h4 terms_web_all_p">
            <!-- <div class="form-head mb-3 text-center">
              <h2 class="golden-text golden_text_seo"><b>Job Seekers</b></h2>
            </div> -->
            <p v-html="terms_and_conditions_ptUser.description" class="rmp_p" :class="isAppView ? 'mt-0' : ''"></p>
          </div>
          <div v-show="x === 'terms_hirers'" class="style_for_all_h3 style_for_all_h4 terms_web_all_p">
            <!-- <div class="form-head mb-3 text-center emp_top">
              <h2 class="golden-text mt-3 golden_text_seo"><b>{{ $t('terms.tab_employers') }}</b></h2>
            </div> -->
            <p v-html="terms_and_conditions_supervisor.description" :class="isAppView ? 'mt-0' : ''"></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Spacer -->
    <div class="margin-top-50 mobile_tab_margin_top_35"></div>
    <!-- Spacer / End-->
  </div>
</template>

<script>
import { POST_API } from "../../store/actions.type";
import { getMetaInfo } from '@/seo.config';

export default {
  metaInfo() { return getMetaInfo('/terms-of-service'); },
  data() {
    return {
      tab_type: 'Employee',
      x: "terms_jobseeker",
      terms_and_conditions_ptUser: "",
      terms_and_conditions_supervisor: "",
      showDismissibleAlert: false,
      error_message: "",
      display: true,
      link_error: "",
      webUrl: process.env.VUE_APP_URL,
    };
  },
  methods: {
    getTermsConditions() {
      return this.$store
        .dispatch(POST_API, {
          data: {
            type: this.tab_type,  
            token: this.email,
          },
          api: "/api/terms-condition",
        })
        .then(() => {
          if (this.$store.getters.containsErrors) {
            this.error_message = this.$store.getters.getErrors;

            this.$swal({
              position: "center",
              icon: "error",
              title: this.error_message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            this.terms_and_conditions_ptUser =
              this.$store.getters.getResults.data[0].key == "terms_and_conditions_ptUser"
                ? this.$store.getters.getResults.data[0]
                : this.$store.getters.getResults.data[1];
            this.terms_and_conditions_supervisor =
              this.$store.getters.getResults.data[1].key == "terms_and_conditions_supervisor"
                ? this.$store.getters.getResults.data[1]
                : this.$store.getters.getResults.data[0];
          }
        });
    },
  },
watch: {
        '$route': {
            immediate: true,
            handler(to) {
            console.log(
                'Route changed. app =',
                to.query.app,
                'language =',
                to.query.language
            )

            /* ---------- language logic (existing) ---------- */
            if (to.query.language && to.query.language !== this.language) {
                this.language = to.query.language
            }

            /* ---------- TAB SWITCH LOGIC (NEW) ---------- */
            if (to.query.app === 'employer') {
                this.x = 'terms_hirers'
                this.tab_type = 'Employer'   
            } else if (to.query.app === 'jobseeker') {
                this.x = 'terms_jobseeker'
                this.tab_type = 'Employee'  
            }
            // else (do nothing)
            }
        }
    },
  mounted() {
    //document.title = "EL Connect - Terms of Service";
    window.scrollTo(0, 0);
    Promise.all([
      this.terms_and_conditions_ptUser ? Promise.resolve() : this.getTermsConditions(),
    ]).finally(() => {
      document.dispatchEvent(new Event('x-app-rendered'));
    });
  },
};
</script>
